export interface PlayerFeedbackState {
    authenticated: boolean;
    telegramPlayer: boolean;
    development: boolean;
    dailyRewardClaimed: boolean;
    settledSpinsCount: string | undefined;
    completedSpinThisVisit: boolean;
}

/** Current app facts only. Survey thresholds and quotas remain in UserReason. */
export function playerFeedbackContext(state: PlayerFeedbackState) {
    const count = state.settledSpinsCount;
    const spins = count && /^\d+$/.test(count) ? BigInt(count) : 0n;
    const largest = BigInt(Number.MAX_SAFE_INTEGER);
    return {
        livePlayer:
            state.authenticated && state.telegramPlayer && !state.development,
        dailyRewardClaimed: state.authenticated && state.dailyRewardClaimed,
        campaignSpinCount: Number(spins > largest ? largest : spins),
        completedSpinThisVisit:
            state.authenticated && state.completedSpinThisVisit,
    };
}
